import * as React from 'react';
import { Box, Button, IconButton, Modal, Stack, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';

const ConfirmModal = (props) => {
    const {handleRemoveAllLineups } = props;
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const onClick = () => {
        handleRemoveAllLineups()
        setOpen(false)
    }
    
    return (
        <div>
            <Button
                onClick={handleOpen}
                variant='text'
                endIcon={<DeleteOutlinedIcon />}
                sx={{
                    fontSize: '12px',
                    color: 'rgba(255, 255, 255, 0.70)'
                }}
            >
                Clear all Lineups
            </Button>
            <Modal
                disablePortal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                sx={{
                    position: 'absolute',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    color: '#FFF'
                }}
            >
                <Stack sx={{
                    width: '300px',
                    backgroundColor: '#1C1C1C',
                    boxShadow: '0px 4px 20px 0px rgba(0, 0, 0, 0.50)',
                    borderRadius: '10px'
                }}> 
                    <Box sx={{
                        display: 'flex',
                        padding: '10px 10px 0px 10px',
                        justifyContent: 'flex-end',
                        alignItems: 'center',
                        gap: '15px',
                        alignSelf: 'stretch',
                    }}>
                        <IconButton color='inherit' onClick={handleClose} aria-label='close drawer' sx={{ p: 0 }}>
                            <CloseIcon />
                        </IconButton>
                    </Box>
                    <Stack gap='15px' sx={{ p: '0px 15px 15px 15px'}} justifySelf={'stretch'}>
                        <Typography color="#FFF" id="modal-modal-title"
                            sx={{
                                textAlign: 'center',
                                fontFamily: 'Inter',
                                fontSize: '18px',
                                fontStyle: 'normal',
                                fontWeight: '700',
                                lineHeight: 'normal',
                            }}>
                            Are you sure you want to remove all lineups from contests?
                        </Typography>
                        <Stack gap='5px' justifySelf='stretch'>
                            <Button
                                onClick={onClick}
                                sx={{
                                    borderRadius: '6px',
                                    background: 'rgba(255, 255, 255, 0.04)',
                                    color: '#FF7070',
                                    '&:hover': {
                                        background: 'rgba(255, 255, 255, 0.04)',
                                    }
                                }}
                                variant='contained'>Yes, Remove Lineups</Button>
                            <Button
                                onClick={handleClose}
                                sx={{
                                    borderRadius: '6px',
                                    color: "#FFF"
                                }}
                                variant='text'>Cancel</Button>
                        </Stack>
                    </Stack>
                </Stack>
            </Modal>
        </div>
    );
}

export default ConfirmModal;



